module.exports = __webpack_public_path__ + "img/project-adaptive-3.jpg?5fec94c51e2dbd657fa7758c2862a240";